import {SmartComponent} from "smart-component-js";
import $ from "jquery";
import GigyaManager from "../business/GigyaManager";
import RestManager from "../business/RestManager";
import moment from "moment";
import Constants from "../business/Constants";
class DefaultCtrl extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.init();
    }
    init() {
        this.loadChildComponents(this);
        if(moment(Constants.CLOSING_STEP_1_DATE, 'DD/MM/YYYY HH:mm').diff(moment()) < 0){
            $('.closingStep1').show();
        }else{
            $('.beforeClosing').show();
        }

    }

    goToPlayReceipt(){

        window.location.href='/promozioni/vinci-il-buongiorno/gioca-scontrino'
    }
}

export default DefaultCtrl;
